export const StatusCode = {
  Success: 0,
  Error: 1,
  Exception: 2,
  InvalidData: 3,
  Failed: 4,
  Invalid: 5,
  SessionExpired: 6,
  AuthenticationFailed: 7,
  AuthorizationFailed: 8,
  MoreActionRequired: 9,
} as const;

export type StatusCodeType = typeof StatusCode[keyof typeof StatusCode];